import React from 'react'
import Header from './Header'
import Sidebar from './Sidebar'

const MainLayout = ({ children, compact = false }: { children: React.ReactNode; compact?: boolean }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className={compact ? 'min-w-0 flex-1 px-3 py-5 sm:px-4' : 'flex-1 p-8'}>{children}</main>
      </div>
    </div>
  )
}

export default MainLayout
